var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVtD(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.7549 67.6656C24.2366 65.7918 28.2508 62.6064 32.4536 64.8549C37.7071 67.6656 38.1112 73.2867 36.4947 76.0974C34.8783 78.908 28.4125 81.3171 24.7754 78.105C21.8658 75.5352 21.5886 73.361 21.858 71.7549",
    stroke: "#9E9C9A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5625 65.5509C85.2458 65.6991 83.5295 69.9875 83.2109 72.1131L83.663 74.351C84.1761 75.7215 86.0637 78.6337 89.5093 79.3188C93.8164 80.1753 97.8092 75.3842 97.8108 72.4693C97.8125 69.5543 94.9583 65.3657 89.5625 65.5509Z",
    stroke: "#9E9C9A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5555 71.8596C13.3035 71.5466 7.08009 70.1696 7.08009 67.1652C7.08009 63.4098 5.14977 39.561 7.08009 36.7445C9.0104 33.9279 10.9407 31.1113 13.8362 31.1113C33.4033 31.1113 53.4094 31.4886 74.6411 31.4886C78.5018 31.4886 90.0837 30.5498 92.014 33.3663C93.9443 36.1829 104.561 50.2658 107.457 54.0212C112.815 60.9707 105.562 70.9208 102.667 71.8596",
    stroke: "#9E9C9A",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1109 37.6372C75.7431 37.6372 25.3369 37.6372 23.0168 37.6372C20.1166 37.6372 11.416 50.0149 31.7174 51.1402C47.9584 52.0404 86.8209 51.5152 104.222 51.1402",
    stroke: "#9E9C9A",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5554 71.8594C52.996 71.8594 70.648 71.8594 77.7776 71.8594",
    stroke: "#9E9C9A",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8889 42C66.8889 43.2874 66.8889 45.6944 66.8889 46.6667",
    stroke: "#EF533F",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7778 42C49.7778 43.2874 49.7778 45.6944 49.7778 46.6667",
    stroke: "#EF533F",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84 42C84 43.2874 84 45.6944 84 46.6667",
    stroke: "#EF533F",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6665 42C32.6665 43.2874 32.6665 45.6944 32.6665 46.6667",
    stroke: "#EF533F",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H112V112H0V0Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVtD);
export default __webpack_public_path__ + "static/media/vt_d.42af3472d80ded52aebd73591060391f.svg";
export { ForwardRef as ReactComponent };